import React, { useState } from "react";
import {
  Row,
  Col,
  Card,
  ListGroup,
  Badge,
  Button,
  Form,
  Tabs,
  Tab,
  Alert
} from "react-bootstrap";
import { 
  FaBell, 
  FaCalendarAlt, 
  FaShoppingBag, 
  FaChartLine, 
  FaUserCog,
  FaTrash,
  FaCheck,
  FaExclamationTriangle,
  FaInfoCircle,
  FaCog,
  FaLine
} from "react-icons/fa";
import { format } from 'date-fns';
import { th } from 'date-fns/locale';

const Notifications = () => {
  const [activeTab, setActiveTab] = useState("all");
  const [notifications, setNotifications] = useState([
    {
      id: 1,
      type: "booking",
      title: "การจองของคุณได้รับการยืนยันแล้ว",
      message: "การจองบริการ Boost Post วันที่ 15 มิถุนายน 2023 เวลา 14:00 น. ได้รับการยืนยันแล้ว",
      date: new Date(2023, 5, 10, 9, 30),
      read: false,
      priority: "medium"
    },
    {
      id: 2,
      type: "package",
      title: "แพ็กเกจของคุณใกล้หมดอายุ",
      message: "แพ็กเกจ Premium Boost จะหมดอายุในอีก 5 วัน กรุณาต่ออายุเพื่อใช้บริการต่อเนื่อง",
      date: new Date(2023, 5, 9, 15, 45),
      read: false,
      priority: "high"
    },
    {
      id: 3,
      type: "ads",
      title: "โฆษณาของคุณเริ่มทำงานแล้ว",
      message: "โฆษณา 'โปรโมชั่นสินค้าใหม่' เริ่มทำงานแล้ว คุณสามารถติดตามผลได้ที่หน้าสถานะโฆษณา",
      date: new Date(2023, 5, 8, 10, 0),
      read: true,
      priority: "medium"
    },
    {
      id: 4,
      type: "system",
      title: "อัปเดตระบบ",
      message: "ระบบได้รับการอัปเดตเป็นเวอร์ชันใหม่ ดูรายละเอียดเพิ่มเติมได้ที่ศูนย์ช่วยเหลือ",
      date: new Date(2023, 5, 5, 8, 15),
      read: true,
      priority: "low"
    },
    {
      id: 5,
      type: "booking",
      title: "เตือนการจองที่กำลังจะถึง",
      message: "คุณมีการจองบริการ Boost Live ในวันพรุ่งนี้ เวลา 18:00 น. กับคุณสมศักดิ์",
      date: new Date(2023, 5, 7, 12, 0),
      read: false,
      priority: "high"
    },
    {
      id: 6,
      type: "package",
      title: "การชำระเงินสำเร็จ",
      message: "การชำระเงินสำหรับแพ็กเกจ Basic Boost สำเร็จแล้ว คุณสามารถใช้บริการได้ทันที",
      date: new Date(2023, 5, 6, 16, 30),
      read: true,
      priority: "medium"
    },
    {
      id: 7,
      type: "ads",
      title: "ผลการทำงานของโฆษณา",
      message: "โฆษณา 'แคมเปญลดราคา' มีผลตอบรับที่ดี ดูรายละเอียดเพิ่มเติมได้ที่หน้าสถานะโฆษณา",
      date: new Date(2023, 5, 4, 14, 45),
      read: true,
      priority: "medium"
    }
  ]);
  
  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertVariant, setAlertVariant] = useState("success");
  const [notificationSettings, setNotificationSettings] = useState({
    email: true,
    browser: true,
    line: false,
    bookingReminders: true,
    packageExpiry: true,
    adsPerformance: true,
    systemUpdates: false
  });
  
  // Filter notifications based on active tab
  const getFilteredNotifications = () => {
    switch(activeTab) {
      case "all":
        return notifications;
      case "unread":
        return notifications.filter(notification => !notification.read);
      case "booking":
        return notifications.filter(notification => notification.type === "booking");
      case "package":
        return notifications.filter(notification => notification.type === "package");
      case "ads":
        return notifications.filter(notification => notification.type === "ads");
      case "system":
        return notifications.filter(notification => notification.type === "system");
      default:
        return notifications;
    }
  };
  
  // Mark notification as read
  const markAsRead = (id) => {
    const updatedNotifications = notifications.map(notification => {
      if (notification.id === id) {
        return { ...notification, read: true };
      }
      return notification;
    });
    
    setNotifications(updatedNotifications);
  };
  
  // Mark all notifications as read
  const markAllAsRead = () => {
    const updatedNotifications = notifications.map(notification => {
      return { ...notification, read: true };
    });
    
    setNotifications(updatedNotifications);
    setAlertVariant("success");
    setAlertMessage("ทำเครื่องหมายอ่านแล้วทั้งหมด");
    setShowAlert(true);
    
    setTimeout(() => {
      setShowAlert(false);
    }, 3000);
  };
  
  // Delete notification
  const deleteNotification = (id) => {
    const updatedNotifications = notifications.filter(notification => notification.id !== id);
    setNotifications(updatedNotifications);
  };
  
  // Handle notification settings change
  const handleSettingsChange = (e) => {
    const { name, checked } = e.target;
    setNotificationSettings({
      ...notificationSettings,
      [name]: checked
    });
  };
  
  // Save notification settings
  const saveSettings = () => {
    // In a real implementation, this would call an API to save the settings
    setAlertVariant("success");
    setAlertMessage("บันทึกการตั้งค่าการแจ้งเตือนเรียบร้อยแล้ว");
    setShowAlert(true);
    
    setTimeout(() => {
      setShowAlert(false);
    }, 3000);
  };
  
  // Render notification icon based on type
  const renderNotificationIcon = (type, priority) => {
    let icon;
    let color;
    
    switch(type) {
      case "booking":
        icon = <FaCalendarAlt />;
        color = "primary";
        break;
      case "package":
        icon = <FaShoppingBag />;
        color = "success";
        break;
      case "ads":
        icon = <FaChartLine />;
        color = "info";
        break;
      case "system":
        icon = <FaCog />;
        color = "secondary";
        break;
      default:
        icon = <FaBell />;
        color = "primary";
    }
    
    if (priority === "high") {
      color = "danger";
    }
    
    return (
      <div className={`notification-icon bg-${color} text-white`}>
        {icon}
      </div>
    );
  };
  
  // Format date to Thai locale
  const formatDate = (date) => {
    const now = new Date();
    const diffInDays = Math.floor((now - date) / (1000 * 60 * 60 * 24));
    
    if (diffInDays === 0) {
      return `วันนี้ ${format(date, 'HH:mm น.')}`;
    } else if (diffInDays === 1) {
      return `เมื่อวาน ${format(date, 'HH:mm น.')}`;
    } else if (diffInDays < 7) {
      return format(date, 'EEEE', { locale: th }) + ` ${format(date, 'HH:mm น.')}`;
    } else {
      return format(date, 'd MMM yyyy HH:mm น.', { locale: th });
    }
  };
  
  return (
    <div className="notifications-page">
      <Row className="mb-4">
        <Col>
          <h1 className="mb-3">การแจ้งเตือน</h1>
          <p className="text-muted">
            จัดการการแจ้งเตือนและข่าวสารสำคัญเกี่ยวกับบริการของคุณ
          </p>
        </Col>
      </Row>
      
      {showAlert && (
        <Alert variant={alertVariant} onClose={() => setShowAlert(false)} dismissible>
          {alertMessage}
        </Alert>
      )}
      
      <Row>
        <Col lg={8} className="mb-4">
          <Card>
            <Card.Header className="d-flex justify-content-between align-items-center">
              <Tabs
                activeKey={activeTab}
                onSelect={(k) => setActiveTab(k)}
                className="mb-0"
              >
                <Tab eventKey="all" title={
                  <div className="d-flex align-items-center">
                    ทั้งหมด
                    <Badge bg="primary" className="ms-2">
                      {notifications.length}
                    </Badge>
                  </div>
                } />
                <Tab eventKey="unread" title={
                  <div className="d-flex align-items-center">
                    ยังไม่ได้อ่าน
                    <Badge bg="danger" className="ms-2">
                      {notifications.filter(n => !n.read).length}
                    </Badge>
                  </div>
                } />
                <Tab eventKey="booking" title="การจอง" />
                <Tab eventKey="package" title="แพ็กเกจ" />
                <Tab eventKey="ads" title="โฆษณา" />
                <Tab eventKey="system" title="ระบบ" />
              </Tabs>
              
              <Button 
                variant="outline-primary" 
                size="sm"
                onClick={markAllAsRead}
                disabled={!notifications.some(n => !n.read)}
              >
                <FaCheck className="me-1" /> ทำเครื่องหมายอ่านแล้วทั้งหมด
              </Button>
            </Card.Header>
            
            <ListGroup variant="flush">
              {getFilteredNotifications().length > 0 ? (
                getFilteredNotifications().map((notification) => (
                  <ListGroup.Item 
                    key={notification.id}
                    className={`d-flex ${!notification.read ? 'bg-light' : ''}`}
                  >
                    <div className="me-3">
                      {renderNotificationIcon(notification.type, notification.priority)}
                    </div>
                    
                    <div className="flex-grow-1" onClick={() => markAsRead(notification.id)}>
                      <div className="d-flex justify-content-between align-items-start">
                        <h6 className={`mb-1 ${!notification.read ? 'fw-bold' : ''}`}>
                          {notification.title}
                          {notification.priority === "high" && (
                            <Badge bg="danger" className="ms-2">สำคัญ</Badge>
                          )}
                        </h6>
                        <small className="text-muted">
                          {formatDate(notification.date)}
                        </small>
                      </div>
                      <p className="mb-1">{notification.message}</p>
                      <div className="d-flex justify-content-end">
                        {!notification.read && (
                          <Button 
                            variant="link" 
                            size="sm" 
                            className="text-primary p-0 me-3"
                            onClick={() => markAsRead(notification.id)}
                          >
                            ทำเครื่องหมายว่าอ่านแล้ว
                          </Button>
                        )}
                        <Button 
                          variant="link" 
                          size="sm" 
                          className="text-danger p-0"
                          onClick={() => deleteNotification(notification.id)}
                        >
                          <FaTrash /> ลบ
                        </Button>
                      </div>
                    </div>
                  </ListGroup.Item>
                ))
              ) : (
                <ListGroup.Item className="text-center py-4">
                  <FaBell className="text-muted mb-2" size={24} />
                  <p className="text-muted mb-0">ไม่มีการแจ้งเตือน</p>
                </ListGroup.Item>
              )}
            </ListGroup>
          </Card>
        </Col>
        
        <Col lg={4}>
          <Card className="mb-4">
            <Card.Header>
              <h5 className="mb-0">
                <FaCog className="me-2" /> ตั้งค่าการแจ้งเตือน
              </h5>
            </Card.Header>
            <Card.Body>
              <h6 className="mb-3">ช่องทางการแจ้งเตือน</h6>
              <Form>
                <Form.Check
                  type="switch"
                  id="email-notifications"
                  label="อีเมล"
                  name="email"
                  checked={notificationSettings.email}
                  onChange={handleSettingsChange}
                  className="mb-2"
                />
                <Form.Check
                  type="switch"
                  id="browser-notifications"
                  label="เว็บเบราว์เซอร์"
                  name="browser"
                  checked={notificationSettings.browser}
                  onChange={handleSettingsChange}
                  className="mb-2"
                />
                <Form.Check
                  type="switch"
                  id="line-notifications"
                  label="LINE"
                  name="line"
                  checked={notificationSettings.line}
                  onChange={handleSettingsChange}
                  className="mb-2"
                />
                
                <hr />
                
                <h6 className="mb-3">ประเภทการแจ้งเตือน</h6>
                <Form.Check
                  type="switch"
                  id="booking-reminders"
                  label="การจองและการเตือนความจำ"
                  name="bookingReminders"
                  checked={notificationSettings.bookingReminders}
                  onChange={handleSettingsChange}
                  className="mb-2"
                />
                <Form.Check
                  type="switch"
                  id="package-expiry"
                  label="แพ็กเกจใกล้หมดอายุ"
                  name="packageExpiry"
                  checked={notificationSettings.packageExpiry}
                  onChange={handleSettingsChange}
                  className="mb-2"
                />
                <Form.Check
                  type="switch"
                  id="ads-performance"
                  label="ผลการทำงานของโฆษณา"
                  name="adsPerformance"
                  checked={notificationSettings.adsPerformance}
                  onChange={handleSettingsChange}
                  className="mb-2"
                />
                <Form.Check
                  type="switch"
                  id="system-updates"
                  label="อัปเดตระบบและข่าวสาร"
                  name="systemUpdates"
                  checked={notificationSettings.systemUpdates}
                  onChange={handleSettingsChange}
                  className="mb-2"
                />
                
                <Button 
                  variant="primary" 
                  className="w-100 mt-3"
                  onClick={saveSettings}
                >
                  บันทึกการตั้งค่า
                </Button>
              </Form>
            </Card.Body>
          </Card>
          
          <Card>
            <Card.Header>
              <h5 className="mb-0">
                <FaInfoCircle className="me-2" /> คำแนะนำ
              </h5>
            </Card.Header>
            <Card.Body>
              <div className="mb-3">
                <div className="d-flex align-items-center mb-2">
                  <FaExclamationTriangle className="text-danger me-2" />
                  <h6 className="mb-0">การแจ้งเตือนสำคัญ</h6>
                </div>
                <p className="text-muted small">
                  การแจ้งเตือนที่มีความสำคัญสูงจะถูกทำเครื่องหมายด้วยแถบสีแดง คุณควรตรวจสอบและดำเนินการโดยเร็ว
                </p>
              </div>
              
              <div className="mb-3">
                <div className="d-flex align-items-center mb-2">
                  <FaLine className="text-success me-2" />
                  <h6 className="mb-0">การแจ้งเตือนผ่าน LINE</h6>
                </div>
                <p className="text-muted small">
                  เพื่อรับการแจ้งเตือนผ่าน LINE คุณต้องเชื่อมต่อบัญชี LINE ของคุณในหน้าโปรไฟล์
                </p>
              </div>
              
              <div>
                <div className="d-flex align-items-center mb-2">
                  <FaUserCog className="text-primary me-2" />
                  <h6 className="mb-0">การปรับแต่งการแจ้งเตือน</h6>
                </div>
                <p className="text-muted small">
                  คุณสามารถปรับแต่งประเภทการแจ้งเตือนที่คุณต้องการรับได้ในส่วนตั้งค่าการแจ้งเตือน
                </p>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>
      
      <style jsx>{`
        .notification-icon {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
      `}</style>
    </div>
  );
};

export default Notifications;
